<script lang="ts">
  import { Card } from '@centerhealth/fe/center-kit';
  import { PLAN_DISPLAY } from '@centerhealth/fe/subscriptions';
  import {
    SubscriptionPlanDisplay,
    SubscriptionPlanVersion,
  } from '@centerhealth/common/subscriptions';
  import type { SubscriptionPlanType } from '@centerhealth/common/subscriptions';
  import { createEventDispatcher } from 'svelte';

  // Enforce type
  const planDisplay: SubscriptionPlanDisplay = PLAN_DISPLAY;

  const version: SubscriptionPlanVersion = 'v5';
  const currentPlanVersion = planDisplay[version];

  export let planTypeSelected: SubscriptionPlanType = '50';

  const dispatch = createEventDispatcher();

  function handleSelect(plan) {
    planTypeSelected = plan;
    dispatch('card-selected', planTypeSelected);
  }

  // Return .selected if the plan of the card matches the selectedPlan
  let getSelectedClass: (plan: string) => string;
  $: getSelectedClass = (plan) => (plan === planTypeSelected ? 'selected' : '');
</script>

<section class="mt-7 md:mt-8 text-gray">
  <div class="container mx-auto grid">
    <slot />
    <div class="card-container">
      {#each Object.entries(currentPlanVersion) as [plan, { colour, stripsPerDay, stripsPerMonth, pricePerMonth }]}
        <Card
          heapAttr={{ action: 'select', subAction: 'sub-plan', value: plan }}
          variant="secondary"
          customClass="flex text-center text-gray-darkest transition transform duration-200 lg:hover:scale-105"
        >
          <div
            on:click={() => handleSelect(plan)}
            class={`inner-card inner-card--${colour} ${getSelectedClass(plan)}`}
          >
            <p class="text-lg mb-2">
              <strong>{stripsPerDay}</strong> per day
            </p>
            <p class="font-semibold leading-[44px] mb-[8px] lg:mb-2">
              <span class="align-top text-lg">$</span><span class="text-5xl">{pricePerMonth}</span
              ><span class="align-top text-lg">00</span><span class="text-lg">/mo</span>
            </p>
            <p class="text-lg leading-tight"><strong>{stripsPerMonth}</strong> strips per month</p>
          </div>
        </Card>
      {/each}
    </div>
    <slot name="note" />
  </div>
</section>

<style lang="postcss">
  .card-container {
    @apply flex flex-col gap-y-4;
    @apply lg:grid lg:grid-cols-2 lg:gap-6 lg:grid-rows-1 lg:px-10;
    @apply xl:px-1/4;
    @apply xxl:px-3/10;
  }
  .inner-card {
    /* offset card original padding */
    margin: -15px;
    border-radius: 20px;
    width: -webkit-fill-available;
    width: -moz-available;
    @apply py-[9px] cursor-pointer transition-all duration-200 lg:py-[25px] lg:px-[25px];
  }
  .inner-card--green:hover {
    @apply lg:bg-green lg:text-white lg:transform lg:scale-105;
  }
  .inner-card--green.selected {
    @apply bg-green text-white transform scale-105;
  }
  .inner-card--blue:hover {
    @apply lg:bg-blue lg:text-white lg:transform lg:scale-105;
  }
  .inner-card--blue.selected {
    @apply bg-blue text-white transform scale-105;
  }
</style>
